// fields to sort by via the API
export const ACCOUNT = 'account_id';
export const CREATED = 'created_time';
export const ID = 'id';
export const NAME = 'name';
export const SPACE = 'space_id';
export const UPDATED = 'updated_time';
